<template>
    <section>
        <MainLayout>
			<div class="container">
				<div class="box">
					<section>
						<b-overlay :show="loadingExport" no-wrap/>
						<form class="container">
							<b-form-row>
								<b-form-group class="col-lg-3 col-12" :label="$t('bookings.serviceDateFrom')">
									<b-form-datepicker :locale="$root.store.state.currentUser.lang" :class="{'active-filter':filters.pickupStartDate}" reset-button size="sm" v-model="filters.pickupStartDate"/>
								</b-form-group>

								<b-form-group class="col-lg-3 col-12" :label="$t('bookings.serviceDateTo')">
									<b-form-datepicker :locale="$root.store.state.currentUser.lang" :class="{'active-filter':filters.pickupEndDate}" reset-button  size="sm" v-model="filters.pickupEndDate"/>
								</b-form-group>

								<b-form-group class="col-md-3" :label="$t('bookings.serviceStatus')">
									<multiselect
										:class="{'active-filter':filters.status.length>0}"
										v-model="filters.status"
										:options="statusOpts"
										group-label="group"
										group-values="options"
										group-select
										multiple
										label="text"
										track-by="value"
										:placeholder="$t('global.all')"
										taggable
									/>
								</b-form-group>

								<div class="col mt-lg-3">
									<b-button variant="outline-primary" type="button" @click="checkform()" class="m-2" v-b-tooltip.hover :title="$t('global.search')"><md-icon icon="search"/></b-button>
									<b-button variant="outline-success" type="button" @click="exportSpreadSheet()" v-b-tooltip.hover :title="$t('bookings.export')"><md-icon icon="note_add"/></b-button>
								</div>
							</b-form-row>
						</form>
					</section>
					<br>
					<b-overlay :show="loading">
						<section v-if="pagination.totalRows>0">
							<b-row>
								<b-col sm class="mt-2">
									<div class="mr-4">
										{{rowsMessage}}
										<b-form-select size="sm" class="ml-2" style="width:80px" v-model="pagination.perPage" :options="pagination.perPageOptions" @change="paginationChanged"></b-form-select>
									</div>
								</b-col>
								<b-col sm class="float-right">
									<b-row no-gutters>
										<b-col >
											<b-pagination
												align="right"
												v-model ="pagination.currentPage"
												:total-rows ="pagination.totalRows"
												:per-page="pagination.perPage"
												@change="paginationChanged"
											/>
										</b-col>
									</b-row>
								</b-col>
							</b-row>
							<b-table
							:sticky-header="true"
							striped
							hover
							small
							ref="tblReportRides"
							:fields="tbl.fields"
							:items = "tbl.items"
							:empty-text="$t('global.ajaxTable.noRecordsFound')"
							show-empty
							stacked="lg"

							>
								<template #thead-top="">
									<b-tr>
										<b-th colspan="200"><span class="sr-only">Name and ID</span>
											<span variant="success" class="float-right text-success">
												Payment amount<sup>*</sup>
												<md-icon icon="price_change" style="margin-bottom:-2px" /> {{willBePaidText}}
											</span>
										</b-th>
									</b-tr>
								</template>
								<template #cell(status)="row">
									<span :class="getClassForStatus(row.item.status)"><b>{{$t("transportServiceStatus."+row.item.status)}}</b></span>
								</template>
								<template #cell(revenue)="row">
									<span :class="{ 'text-danger': (row.item.revenue<0) }"><b>{{row.item.revenue}}</b></span>
								</template>
								<template #cell(revenueCurrency)="row">
									<span class="text-uppercase">{{row.item.revenueCurrency}}</span>
								</template>
							</b-table>
						</section>
						<section v-else>
							{{$t('global.ajaxTable.noRecordsFound')}}
						</section>
					</b-overlay>
				</div>
			</div>
		</MainLayout>
	</section>
</template>
<script>
    import MainLayout from '../../layout/MainLayout.vue'
    import moment from 'moment'
	import Multiselect from 'vue-multiselect'
	import helpers from '../helpers/Reports.js'
    export default {
        name: "Index",
        components:{MainLayout,Multiselect},
		mixins:[helpers],
        data(){
            let pickUpStart = moment().subtract(7, 'days').format("YYYY-MM-DD");
            let pickUpEnd = moment().subtract(1, 'days').format("YYYY-MM-DD");
			const fields = [
					{ key: "serviceNumber", label: "ID" },
					{ key: "fullName", label: this.$t("users.name") },
					{ key: "pax", label: this.$t("bookings.paxes") },
					{ key: "pickupDatetime", label: this.$t("bookings.pickupDatetime") },
					{ key: "status", label: this.$t("users.status") },
					{ key: "serviceTypeName", label: this.$t("bookings.serviceType") },
					{ key: "revenue", label: this.$t("reports.rate") },
					{ key: "revenueCurrency", label: this.$t("reports.currency") },
					{ key: "pickupName", label: this.$t("bookings.pickup") },
					{ key: "dropoffName", label: this.$t("bookings.dropoff") }
			];

			const optsShow =[
				{value:10,text:10},
				{value:50,text:50},
				{value:100,text:100},
				{value:200,text:200},
				{value:500,text:500},
			]

            return {
				loading:false,
				loadingExport:false,
				filters:{
					pickupStartDate:pickUpStart,
					pickupEndDate:pickUpEnd,
					status:[],
				},
				pagination:{
					perPage:10,
					currentPage:1,
					totalRows:0,
					perPageOptions:optsShow
				},
				tbl:{
					fields:fields,
					items:[],
				},
				grandTotal:{
					amount:0,
					currency:""
				}
			}
		},
		methods:{
			checkform(){
				this.pagination.currentPage =1;
				let errors = [];
				if(this.$root.isEmpty(this.filters.pickupStartDate) || this.$root.isEmpty(this.filters.pickupEndDate)){
					errors.push("Fecha inicio y fecha fin son requeridos");
				}
				if(errors.length===0){
					try{
						let startDate = moment(this.filters.pickupStartDate);
						let endDate   = moment(this.filters.pickupEndDate);
						this.dateRangeLimit(startDate,endDate)
						this.search();
					}catch(err){
						console.warn(err)
					}
                }else{
                    this.$root.showAlert(this.$t("reports.datesValidation"),{variant:'warning'});
                }
			},
			paginationChanged(){
				setTimeout(() => {
					this.search();
				},0);
			},
			search(){
				this.loading = true;
				this.$root.api.get(`reports/rides`,{
					params:{
						limit  :this.pagination.perPage,
						offset :this.offset,
						filters :this.filtersClean
					}
				}).then((res) => {
					this.tbl.items            = res.data.rows
					this.pagination.totalRows = res.data.totalRows
					this.grandTotal           = res.data.grandTotal
				})
				.catch(this.$root.handleRequestError)
				.finally(()=>{
					this.loading = false;
				})
			},
			exportSpreadSheet(){
				try{
					let startDate = moment(this.filters.pickupStartDate);
					let endDate   = moment(this.filters.pickupEndDate);
					this.dateRangeLimit(startDate,endDate)
				}catch(err){
					console.warn(err)
					return;
				}
				this.loadingExport = true
				this.$root.api.get(`reports/rides/`,{
					params:{
						filters:this.filtersClean,
						lang:this.$root.store.state.currentUser.lang,
						format:"spreadsheet"
					},
					responseType: "blob"
				}).then((res) => {
					this.downloadSpreadsheet(res,"Rides");
				}).catch(error => {
					this.$root.handleRequestError(error)
				}).finally(()=>{this.loadingExport = false});

			},
			getClassForStatus(status){
				let varClass = {
					noProvided: "text-danger",
					noShow:"text-warning",
					canceled:"text-secondary"
				};

				return varClass[status]??"";
			},
			downloadSpreadsheet(res, fileName) {
				let fileURL = window.URL.createObjectURL(new Blob([res.data]));
				let fileLink = document.createElement("a");
				fileLink.href = fileURL;
				fileLink.setAttribute("download", fileName + ".xlsx");
				document.body.appendChild(fileLink);
				fileLink.click();
				window.URL.revokeObjectURL(fileURL);
			},
			formatNumber(number) {
				// Convert number to string
				let strNumber = number.toString();

				// Split the string into integer and decimal parts (if any)
				let parts = strNumber.split(".");
				let integerPart = parts[0];
				let decimalPart = parts[1];

				// Add commas to the integer part
				let formattedNumber = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

				// Combine the integer and decimal parts (if any)
				if (decimalPart) {
					formattedNumber += "." + decimalPart;
				}

				return formattedNumber;
			}
		},
		computed:{
			filtersClean(){
				let filters = {...this.filters};
				if(!this.$root.isEmpty(filters.status)){
					filters.status = filters.status.map((ele)=>{
						return ele.value;
					})
				}
				return filters;
			},
			offset(){
				let offset = this.pagination.perPage * (this.pagination.currentPage - 1 );
				return offset;
			},
			statusOpts() {
				return [{
					group: this.$t('global.selectAll'),
					options: this.$root.auxVars.transportServiceStatusOpts.map(opt => ({
						value: opt.value,
						text: this.$t(`bookings.serviceStatusOpts.${opt.value}`)
					}))
				}]
			},

			rowsMessage() {
				return this.$t("global.ajaxTable.showingNRecords", {
					from: this.offset+1,
					to: Math.min(this.offset+this.pagination.perPage,this.pagination.totalRows) ,
					total: this.pagination.totalRows
				});
			},
			willBePaidText(){
				let floatAmount = parseFloat(this.grandTotal.amount).toFixed(2)
				floatAmount     = this.formatNumber(floatAmount);
				return "$"+floatAmount +" "+this.grandTotal.currency.toUpperCase()
			}

		},
		mounted(){
			this.search();
        },
    }
</script>


